//@flow
import * as React from 'react';
import styled from 'styled-components';
import Logo from './../icons/favicon.svg';
import { setLanguage } from './../i18n';
import { Slide, ToastContainer } from 'react-toastify';
import Modal from './../containers/content/modal/Modal';
import Background from './background/Background';
import LanguageChanger from './LanguageChanger';
import VersionSpan from './VersionSpan';
import { connect } from 'react-redux';

const BodyWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const StyledSignUpWindow = styled.div`
    overflow: auto;
    max-height: 100vh;
    position: absolute;
    min-height: 300px;
    min-width: 310px;
    background-color:white;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
    border-radius: 2px;  
`;
const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 175px;
`;
const StyledLogo = styled.img`
    width: 50px;
    margin: 5px;
`;

const StyledSpan = styled.span`
  user-select: none;
  z-index: 1;
  text-decoration: none;
  color: #1f1f1f;
  letter-spacing: .5px;
  font-size: 1.4rem;
  margin: 5px;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 65px;
  flex-direction: row;
`;

type Props = {
    children: any,
}

class SignIn extends React.Component<Props, State> {

    constructor(props){
        super(props)
        setLanguage(props.oneLanguage);
    }

    render(): React.Node {
        const { children }: Props = this.props;
        return (
            <BodyWrapper>
                <ToastContainer
                    draggablePercent={60}
                    transition={Slide}
                />
                <Background />
                <LanguageChanger visible={!this.props.oneLanguage}/>
                <StyledSignUpWindow >
                    <StyledHeader>
                        <StyledLogo src={Logo} />
                        <StyledSpan>                            
                            {this.props.appName}
                        </StyledSpan>
                        <VersionSpan />
                    </StyledHeader>
                    <ContentWrapper>
                        {children}
                    </ContentWrapper>
                </StyledSignUpWindow>

                <Modal ref={(translatedNode) => {
                    if (translatedNode !== null) {
                        modalInstance = translatedNode.getWrappedInstance()
                    }
                }} />

            </BodyWrapper >
        );
    }
};

const mapStateToProps = (state: State) => ({
    appName: state.domainProperties.get('appName'),
    oneLanguage: state.domainProperties.get('oneLanguage'),
});
export default connect(mapStateToProps, null)(SignIn);

export let modalInstance: ModalInstance;


// WEBPACK FOOTER //
// ./src/components/MainPageContainer.jsx